import type { CrmTranslate } from './crm-copy';

export function createCrmRecordViewsCopy(t: CrmTranslate) {
  return {
    dealView: {
      fallbacks: {
        deal: t('crm.dealView.fallbacks.deal'),
        unknown: t('crm.dealView.fallbacks.unknown'),
        notSet: t('crm.dealView.fallbacks.notSet'),
      },
      states: {
        noneSelectedTitle: t('crm.dealView.states.noneSelectedTitle'),
        noneSelectedDescription: t('crm.dealView.states.noneSelectedDescription'),
        notFoundTitle: t('crm.dealView.states.notFoundTitle'),
        notFoundDescription: t('crm.dealView.states.notFoundDescription'),
        noActivityTitle: t('crm.dealView.states.noActivityTitle'),
        noActivityDescription: t('crm.dealView.states.noActivityDescription'),
      },
      actions: {
        backToDeals: t('crm.dealView.actions.backToDeals'),
        edit: t('crm.dealView.actions.edit'),
        delete: t('crm.dealView.actions.delete'),
        confirm: t('crm.dealView.actions.confirm'),
        cancel: t('crm.dealView.actions.cancel'),
      },
      tabs: {
        overview: t('crm.dealView.tabs.overview'),
        activity: t('crm.dealView.tabs.activity'),
      },
      sections: {
        dealInformation: t('crm.dealView.sections.dealInformation'),
        company: t('crm.dealView.sections.company'),
        contactInformation: t('crm.dealView.sections.contactInformation'),
        description: t('crm.dealView.sections.description'),
        details: t('crm.dealView.sections.details'),
      },
      infoLabels: {
        dealName: t('crm.dealView.infoLabels.dealName'),
        amount: t('crm.dealView.infoLabels.amount'),
        stage: t('crm.dealView.infoLabels.stage'),
        probability: t('crm.dealView.infoLabels.probability'),
        expectedCloseDate: t('crm.dealView.infoLabels.expectedCloseDate'),
        companyName: t('crm.dealView.infoLabels.companyName'),
        contactName: t('crm.dealView.infoLabels.contactName'),
        email: t('crm.dealView.infoLabels.email'),
        created: t('crm.dealView.infoLabels.created'),
        lastUpdated: t('crm.dealView.infoLabels.lastUpdated'),
      },
      confirmations: {
        deleteTitle: t('crm.dealView.confirmations.deleteTitle'),
        deleteMessage: (name: string) =>
          t('crm.dealView.confirmations.deleteMessage', {
            values: { name },
          }),
      },
      messages: {
        updateFailed: (message: string) =>
          t('crm.dealView.messages.updateFailed', {
            values: { message },
          }),
        deleteFailed: (message: string) =>
          t('crm.dealView.messages.deleteFailed', {
            values: { message },
          }),
      },
      errors: {
        noDealId: t('crm.dealView.errors.noDealId'),
        noDealIdProvided: t('crm.dealView.errors.noDealIdProvided'),
        dealNotFound: t('crm.dealView.errors.dealNotFound'),
        fetchConsole: t('crm.dealView.errors.fetchConsole'),
      },
    },
    dealQuickView: {
      title: t('crm.dealQuickView.title'),
      actions: {
        viewFullDetails: t('crm.dealQuickView.actions.viewFullDetails'),
        deleting: t('crm.dealQuickView.actions.deleting'),
      },
      sections: {
        basicInformation: t('crm.dealQuickView.sections.basicInformation'),
      },
      infoLabels: {
        updated: t('crm.dealQuickView.infoLabels.updated'),
      },
      messages: {
        deleted: t('crm.dealQuickView.messages.deleted'),
      },
    },
  };
}
